import { network } from './contracts';
import {
  PostConditionMode,
  makeStandardSTXPostCondition,
  createAssetInfo,
  makeStandardFungiblePostCondition,
  FungibleConditionCode,
  callReadOnlyFunction,
  cvToJSON,
  standardPrincipalCV,
  contractPrincipalCV,
  uintCV,
  stringAsciiCV,
  ClarityType,
  makeContractSTXPostCondition,
  someCV,
  AnchorMode,
  tupleCV,
  makeStandardNonFungiblePostCondition,
  makeContractNonFungiblePostCondition,
  NonFungibleConditionCode,
  listCV,
} from '@stacks/transactions';
import { openContractCall } from '@stacks/connect';
import BigNum from 'bn.js';

export function getSaleStatus(contractAddress: string, contractName: string, callback: any) {
  const functionArgs: any[] = [];

  const options: any = {
    contractAddress: contractAddress,
    contractName: contractName,
    functionName: 'get-sale-status',
    network: network,
    functionArgs,
    senderAddress: contractAddress,
  };

  callReadOnlyFunction(options)
    .then((res) => {
      const limit = cvToJSON(res).value.value;
      callback(limit);
    })
    .catch((err) => console.log(err));
}

export async function getPrivateTargetBlockHeight(contractAddress: string, contractName: string) {
  const functionArgs: any[] = [];

  const options: any = {
    contractAddress: contractAddress,
    contractName: contractName,
    functionName: 'get-private-target-block-height',
    network: network,
    functionArgs,
    senderAddress: contractAddress,
  };

  const res = await callReadOnlyFunction(options);
  const blockHeight = cvToJSON(res).value;
  return blockHeight;
}

export async function getPublicTargetBlockHeight(contractAddress: string, contractName: string) {
  const functionArgs: any[] = [];

  const options: any = {
    contractAddress: contractAddress,
    contractName: contractName,
    functionName: 'get-public-target-block-height',
    network: network,
    functionArgs,
    senderAddress: contractAddress,
  };

  const res = await callReadOnlyFunction(options);
  const blockHeight = cvToJSON(res).value;
  return blockHeight;
}

export async function getPrivatePresaleBalance(
  contractAddress: string,
  contractName: string,
  buyerAddress: string,
  callback: any,
) {
  const functionArgs: any[] = [standardPrincipalCV(buyerAddress)];

  const options: any = {
    contractAddress: contractAddress,
    contractName: contractName,
    functionName: 'get-private-presale-balance',
    network: network,
    functionArgs,
    senderAddress: contractAddress,
  };

  callReadOnlyFunction(options)
    .then((res) => {
      const passes = cvToJSON(res).value;
      callback(passes);
    })
    .catch((err) => console.log(err));

  // const res = await callReadOnlyFunction(options);
  // const blockHeight = cvToJSON(res).value;
  // return blockHeight;
}

export function claim(
  contractAddress: string,
  contractName: string,
  salePrice: number,
  claimNumber: number,
  symbol: string,
  buyerAddress: string,
  modalCallback: any,
  functionName: string,
  fts: Array<any>,
) {
  const functionArgs: any[] = [];

  let standardFungiblePostCondition;
  standardFungiblePostCondition = makeStandardSTXPostCondition(
    buyerAddress,
    FungibleConditionCode.LessEqual,
    new BigNum(salePrice),
  );

  let contractPostCondition = makeContractSTXPostCondition(
    contractAddress,
    contractName,
    FungibleConditionCode.LessEqual,
    new BigNum(salePrice),
  );

  const options: any = {
    contractAddress: contractAddress,
    contractName: contractName,
    functionName: functionName,
    network: network,
    functionArgs,
    // postConditions: [],
    postConditionMode: PostConditionMode.Allow,
    appDetails: {
      name: 'Gamma.io',
    },
    onFinish: (data: any) => {
      console.log('claim finished');
      let txid = '';
      if (typeof data.txId === 'string' || data.txId instanceof String) {
        txid = data.txId;
      } else {
        txid = data.txId.txid;
      }
      modalCallback({
        success: true,
        successTransaction: txid,
      });
    },
    // onCancel: () => {
    //   console.log("claim cancelled");
    //   modalCallback({
    //     success: false,
    //     errorMessage: "Transaction Cancelled",
    //   });
    // },
  };

  console.log(options);
  

  openContractCall(options);
}